import statusCodes from "api/statusCode.json";
import { message } from "antd";

export const errorHandler = (error, t) => {
  // 安全檢查：確保 error.response 和 error.response.data 存在
  if (!error || !error.response || !error.response.data) {
    console.error("Error without response data:", error);
    const fallbackMessage = t
      ? t("statusCode.unknownError")
      : "發生未知錯誤，請稍後再試";
    message.open({ type: "error", content: fallbackMessage, duration: 10 });
    return;
  }

  const errorCode = error.response.data.code;
  const comparedResult = statusCodes.statusCodes.find(
    (status) => status.code === errorCode
  );
  console.log("comparedResult", comparedResult);
  const errorMessage = comparedResult
    ? t(`statusCode.${comparedResult.message}`)
    : error.response.data.message;
  message.open({ type: "error", content: errorMessage, duration: 10 });
};
